module.exports = __webpack_public_path__ + "media/era_sweepstakes/member-60a01c5d.svg";